import React, { ReactNode } from 'react';
import { Box, BlankState, SectionHeader } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  emptyContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '220px',
    background: 'white',
    boxShadow: '0px 8px 16px rgba(206, 206, 210, 0.5)',
    borderRadius: '16px'
  },
  emptyHelper: {
    color: theme.color.text.textTertiary
  }
}));

const Blank = ({ header, content }: { header: string; content: ReactNode }) => {
  const { classes } = useStyles();

  return (
    <>
      {header !== '' && <SectionHeader title={header} />}
      <Box className={classes.emptyContainer}>
        <BlankState label={content} />
      </Box>
    </>
  );
};
export default Blank;
